const intro = (
  <p>
    <strong>Serie</strong> to ukazujące się cyklicznie na Remedium wideo, które
    dzielą się na kolejne odsłony czy odcinki. Wszystkie w jednej zakładce.
  </p>
);

const content = (
  <>
    <h3>Podcasty medyczne</h3>
    <p>
      Prowadzimy publikowane w formie wideo serie, które są w istocie podcastami
      medycznymi. Znajdziesz tu treści przygotowane z myślą o lekarzach i
      lekarkach z różnych dziedzin. Zawsze mówimy o tym, co aktualne i
      merytoryczne, a na tematy medyczne wypowiadają się eksperci ze swoich
      dziedzin.
    </p>
    <h3>Merytoryczne dyskusje i lifestylowe rozmowy</h3>
    <p>
      Serie to nie tylko eksperckie dyskusje, takie jak silnie merytoryczne
      “Medyczne espresso”, “5 minut o leku” czy “Hot takes in”. Wiemy, że życie
      lekarzy i lekarek to nie tylko szpital, więc prowadzimy także lifestylowe
      rozmowy “Swoją Drogą”, zawsze związane z medycyną.
    </p>
  </>
);

export const videoSeriesDescription = { intro, content };
